$(document).ready(function(){
  
  //Affix Main Menu

  $('.mainMenu-wrap').affix({
    offset: {
      top: 85
      /*top: function () {
        return (this.top = $('.fixed-nav-wrapper').outerHeight(true) + 67)
      }*/
    }
  });
  
  //Flexslider
  $('.flexslider').flexslider({
    animation: "fade"
  });
  
  //Fancybox
  $('.fancybox').fancybox();
  $('.gallery').fancybox();
  
});